import * as React from 'react';

export function IconCrown(): JSX.Element {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             width="1em"
             height="1em"
             viewBox="0 0 32 32">
            <path fill="currentColor" d="M23 15l-7-9-7 9-9-9 2 20h28l2-20z"/>
        </svg>
    );
}
